var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2428 16.7376C27.2428 18.9586 29.0459 20.759 31.2702 20.759C31.5151 20.7578 31.7594 20.7343 32 20.6888V28.6615C32 32.0156 30.0215 34 26.6624 34H19.3464C15.9785 34 14 32.0156 14 28.6615V21.3561C14 18.002 15.9785 16 19.3464 16H27.3131C27.2659 16.243 27.2423 16.49 27.2428 16.7376ZM25.15 26.8966L28.0078 23.2088V23.1912C28.2525 22.8625 28.1901 22.3989 27.8671 22.1463C27.7108 22.0257 27.5122 21.9735 27.3167 22.0016C27.1211 22.0297 26.9453 22.1358 26.8295 22.2956L24.4201 25.3951L21.6766 23.2351C21.52 23.1131 21.3207 23.0592 21.1238 23.0856C20.9269 23.1121 20.749 23.2166 20.6302 23.3756L17.6756 27.1863C17.5718 27.3158 17.5159 27.4771 17.5173 27.6429C17.5002 27.9781 17.7119 28.2826 18.0324 28.3838C18.3529 28.485 18.7014 28.3573 18.8803 28.0732L21.3512 24.8771L24.0948 27.0283C24.2508 27.1541 24.4514 27.2111 24.6504 27.1863C24.8494 27.1615 25.0297 27.0569 25.15 26.8966Z",
    fill: "#130F26"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 31.5,
    cy: 16.5,
    r: 2.5,
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash2);
export default __webpack_public_path__ + "static/media/Dash2.13a697a49e14d6d2911aea9e0bb52d05.svg";
export { ForwardRef as ReactComponent };